import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, SIZES } from "@/lib/api";
import { useData } from "@/lib/data";
import { Printer } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function CuttingPrint() {
  const { id } = useParams();
  const { productById } = useData();
  const [cut, setCut] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => { api.get(`/cutting/${id}`).then((r) => setCut(r.data)).catch(() => setFailed(true)); }, [id]);

  if (failed) return <div className="p-10 text-red-600" data-testid="cutting-print-not-found">Kesim bulunamadı.</div>;
  if (!cut) return <div className="p-10 text-gray-500">Yükleniyor...</div>;

  const rows = [];
  cut.items.forEach((i) => {
    let r = rows.find((x) => x.pid === i.product_id);
    if (!r) { r = { pid: i.product_id, sole: i.sole_code ? `${i.sole_code}${i.sole_color ? " / " + i.sole_color : ""}` : "", sizes: {}, total: 0 }; rows.push(r); }
    r.sizes[i.size] = (r.sizes[i.size] || 0) + i.qty; r.total += i.qty;
  });
  const grand = rows.reduce((a, r) => a + r.total, 0);

  return (
    <div className="min-h-screen bg-white text-black" data-testid="cutting-print-page">
      <div className="max-w-[1000px] mx-auto p-8 sm:p-12">
        <div className="flex justify-end mb-6 print:hidden">
          <button onClick={() => window.print()} data-testid="cutting-print-btn"
            className="flex items-center gap-2 bg-[#D97706] hover:bg-[#B45309] text-white px-5 h-11 rounded-md font-display uppercase tracking-wide">
            <Printer className="w-4 h-4" /> Yazdır
          </button>
        </div>
        <div className="flex justify-between items-start border-b-2 border-black pb-4 mb-6">
          <div>
            <Logo dark className="text-4xl" subtitle="Ayakkabı Üretim" testId="print-logo" />
            <h1 className="font-display text-2xl font-extrabold uppercase tracking-tight mt-4" data-testid="print-title">Kesim Listesi</h1>
          </div>
          <div className="text-right text-sm font-mono">
            <p>No: <b data-testid="cutting-print-no">{cut.id.slice(0, 8).toUpperCase()}</b></p>
            <p>Tarih: {new Date(cut.created_at).toLocaleDateString("tr-TR")}</p>
            <p>Kesici: <b data-testid="cutting-print-cutter">{cut.cutter_name || "—"}</b></p>
          </div>
        </div>
        <table className="w-full text-sm border border-black">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-black px-2 py-1.5 text-left">Model</th>
              <th className="border border-black px-2 py-1.5 text-left">Renk</th>
              <th className="border border-black px-2 py-1.5 text-left">Taban</th>
              {SIZES.map((s) => <th key={s} className="border border-black px-1 py-1.5 text-center w-9">{s}</th>)}
              <th className="border border-black px-2 py-1.5 text-right">Toplam</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const p = productById(r.pid);
              return (
                <tr key={r.pid} data-testid={`cutting-print-row-${r.pid}`}>
                  <td className="border border-black px-2 py-1.5 font-mono font-semibold">{p?.model_code || "—"}</td>
                  <td className="border border-black px-2 py-1.5">{p?.model_color || "—"}</td>
                  <td className="border border-black px-2 py-1.5 text-xs">{r.sole || "—"}</td>
                  {SIZES.map((s) => <td key={s} className="border border-black px-1 py-1.5 text-center font-mono">{r.sizes[s] || ""}</td>)}
                  <td className="border border-black px-2 py-1.5 text-right font-mono font-bold">{r.total}</td>
                </tr>
              );
            })}
            <tr className="font-bold">
              <td colSpan={13} className="border border-black px-2 py-1.5 text-right">GENEL TOPLAM</td>
              <td className="border border-black px-2 py-1.5 text-right font-mono" data-testid="cutting-print-total">{grand}</td>
            </tr>
          </tbody>
        </table>
        {cut.note && <p className="text-sm mt-4">Not: {cut.note}</p>}
        <div className="grid grid-cols-2 gap-10 mt-16 text-sm text-center">
          <div className="border-t border-black pt-2">Hazırlayan</div>
          <div className="border-t border-black pt-2">Kesimhane</div>
        </div>
      </div>
    </div>
  );
}
